import React from 'react'
import clsx from 'clsx'
import styles from './PageContainer.module.scss';

type PageContainerProps = {
  className?: string,
  style?: any,
  children?: React.ReactNode,
}

function PageContainer({
  className,
  style,
  children,
}: PageContainerProps) {
  return (
    <div
      className={clsx(
        styles.container,
        className && className,
      )}
      style={style}
    >
      <div className={styles.containerInner}>
        {children}
      </div>
    </div>
  )
}

export default PageContainer
